const borderRadiusMedium = '8px';

export { borderRadiusMedium };
